import { IppicaHeaderDetailsBox } from '../ippicaHeaderDetailsBox';
import { IppicaHeaderNumeroCorsa } from '../ippicaHeaderNumeroCorsa';
import { IppicaInfoListItem } from '../ippicaInfoListItem';
import { capitalize } from 'utility/functions';
import styles from './IppicaHeaderInfo.module.scss';
import { useGetLabelByKey } from 'hooks/useLingUI';
import { useTypedSelector } from 'lib/centralStore';
import useWindowSize from 'hooks/useWindowSize';

export type IppicaHeaderInfoProps = {
  hasMarginRight?: boolean;
};

export const IppicaHeaderInfo = ({ hasMarginRight }: IppicaHeaderInfoProps) => {
  const labelTipo = useGetLabelByKey('tipo-di-corsa');
  const labelDistanza = useGetLabelByKey('distanza');
  const labelPremio = useGetLabelByKey('premio');
  const labelPista = useGetLabelByKey('pista');

  const { isMobile } = useWindowSize();

  const { descrizionePremio, tipoGara, distanza, pista } =
    useTypedSelector((state) => state.ippica.ippicaDetailRace!) || {};
  return (
    <div className={`${styles.container} ${hasMarginRight ? styles.withMarginRight : ''} `}>
      {!isMobile && (
        <div className={styles.firstCol}>
          <IppicaHeaderNumeroCorsa />
          <IppicaHeaderDetailsBox />
        </div>
      )}
      <ul className={`${styles.list} ${styles.antepost}`}>
        {!isMobile && (
          <IppicaInfoListItem className={styles.title} title={labelPremio!} textType={'medium'}>
            {descrizionePremio ? capitalize(descrizionePremio) : '-'}
          </IppicaInfoListItem>
        )}

        <IppicaInfoListItem className={styles.title} title={labelTipo!} textType={'medium'}>
          {tipoGara ? tipoGara : '-'}
        </IppicaInfoListItem>
        <IppicaInfoListItem className={styles.title} title={labelDistanza!} textType={'medium'}>
          {distanza ? distanza : '-'}
        </IppicaInfoListItem>

        <IppicaInfoListItem className={styles.title} title={labelPista!} textType={'medium'}>
          {pista ? pista : '-'}
        </IppicaInfoListItem>
      </ul>
    </div>
  );
};
